module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0205.64472bed.jpg";